import createRoutine from '@/utils/createRoutine'

export const notificationMessagesRoutine = createRoutine('notificationMessagesRoutine')

export const notificationMessagesGetters = {
  HAS_NEW_NOTIFICATION_MESSAGES: 'HAS_NEW_NOTIFICATION_MESSAGES'
}

export const NOTIFICATION_MESSAGES_CLEANUP = 'NOTIFICATION_MESSAGES_CLEANUP'
